import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { FileUploader, FileItem, FileLikeObject } from 'ng2-file-upload';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { config } from '@app/service/config.service';
import { UtilService } from '@app/service/util.service';
import { Globals } from '@app/service/globals.service';
import { CommonCodeService } from '@app/admin/service/common.code.service';
import { InspectionBasicService } from '@app/admin/service/inspectionbasic.service';

import { HMemberService } from '@app/home/service/member.service';
import { HInspectionService } from '@app/home/service/inspection.service';

const URL = config.apiInspectionUploadUrl;

@Component({
  selector: 'app-application-modal4',
  templateUrl: './application-modal4.component.html',
  styleUrls: ['./application-modal4.component.scss']
})
export class ApplicationModal4Component implements OnInit {
  public seq = '';
  public btnName: string = '신청';

  public form: FormGroup;
  public formErrors = {};

  public com_gbn: String;

  viewMode = false;

  // 파일 업로드
  public uploader: FileUploader;
  public uploadProgress: any = 0;

  // 업로드 도메인
  public baseURL = config.baseUrl

  commonList = [];
  commonDetailList = [];
  productList = [];
  inspectionList = [];
  inspectionKSList = [];
  IRGCodeGasArray: any = [];
  requestList: any = [];

  now_item_gbn_code: '';
  now_item_code: '';
  now_item_seq: '';

  readonly applicationKindOptions = ['전항목', '파생모델', '동일모델', '보완요구 항목 재시험'];
  /** 신청종류와 자유 입력 메모 구분용 (저장 형식: 신청종류 || 메모) */
  readonly applicationKindDelimiter = ' || ';

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    private commonCodeService: CommonCodeService,
    private InspectionBasicService: InspectionBasicService,
    private toastrService: ToastrService,
    private globals: Globals,
    public utilService: UtilService,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private hMemberService: HMemberService,
    private hInspectionService: HInspectionService
  ) {
    this.buildForm();

    this.getCompanyInfo();
  }

  /*******************************************************************************
    설  명 : 회사 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getCompanyInfo(): void {
    this.hMemberService.getCompanyInfoLogin().then((response) => {
      if( response.ResultCode && response.data && response.data.length > 0 ) {
        this.form.patchValue(response.data[0]);
        this.form.patchValue({
          company_name: response.data[0].com_kor, 
          com_address: response.data[0].address,
          com_tel: response.data[0].tel,
          com_fax: response.data[0].fax,
          applicant_name: response.data[0].username,
          applicant_hp: response.data[0].mobile,
          applicant_email: response.data[0].email,
        });

        this.com_gbn = response.data[0].com_gbn;

      }

      this.form.patchValue({'application_date': moment().format('YYYY-MM-DD')});
    });
  }

 /*******************************************************************************
    설  명 : 검사신청 첨부파일 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getInspectionApplicationFile(): void {
    this.hInspectionService.getInspectionApplicationFile(this.seq).then( response => {
      let files= [];
      this.form.patchValue( {tab4_files: files} );
      if( response.ResultCode && response.data && response.data.length > 0 ) {
        for( let list of response.data ) {
          files.push({
            seq: list.seq,
            url: list.upload_file,
            origin: list.org_upload_file,
            size: list.file_size,
            thumbnail: list.thumbnail,
            thumbnail_result: '',
          });
        }  
        this.form.patchValue( {tab4_files: files} );
      }
    });
  }
  

  /*******************************************************************************
   설  명 : 시험 검사신청 조회
    입력값 : 없음
    리턴값 : 없음
    *******************************************************************************/
    getInspectionApplicationInfo() {
    this.hInspectionService.getInspectionApplicationInfo(this.seq).then( response => {
      if ( response.ResultCode ) {

        for(let key in this.form.value) {
          if( key.substr(0, 5) === 'tab4_' ) {
            let key1 = key.substr((key.length - 5) * -1);
            this.form.patchValue({[key] : response.data[0][key1]});
          } else {
            this.form.patchValue({[key] : response.data[0][key]});
          }
        }  
        this.com_gbn = response.data[0].com_gbn;
        this.form.patchValue({application_date: response.data[0].application_date.substr(0, 10)});
        this.form.patchValue({tab4_agree: true});
        this.restoreApplicationKindFromMemo();
        this.getInspectionApplicationFile();

        // selectbox selected 처리
        this.now_item_gbn_code = response.data[0].item_gbn_code;
        this.now_item_code = response.data[0].item_code;
        this.now_item_seq = response.data[0].item_seq;
        this.onClickBtn('', 'gbn_code');
        this.onChange('');
        this.onChangeItem('');
        this.now_item_gbn_code = '';
        this.now_item_code = '';
        this.now_item_seq = '';
      } 
    });
  }

  /*******************************************************************************
    설  명 : 수정 시 요청메모에서 신청종류 라디오 복원 후 메모에서 제거(중복 방지)
  *******************************************************************************/
  restoreApplicationKindFromMemo() {
    const memo = (this.form.value.tab4_request_memo || '').trim();
    if (!memo) return;

    const parsed = this.parseRequestMemoKind(memo);
    if (parsed.kind) {
      this.form.patchValue({
        tab4_radio: parsed.kind,
        tab4_request_memo: parsed.memo
      });
    }
  }

  /*******************************************************************************
    설  명 : 요청메모에서 신청종류/자유메모 분리
  *******************************************************************************/
  parseRequestMemoKind(memo: string): { kind: string; memo: string } {
    const text = (memo || '').trim();
    if (!text) return { kind: '', memo: '' };

    // 신규 형식: 신청종류 || 메모
    if (text.includes('||')) {
      const parts = text.split(/\s*\|\|\s*/).map((part) => part.trim());
      const kind = parts[0] || '';
      const rest = parts.slice(1).join(this.applicationKindDelimiter).trim();
      if (this.applicationKindOptions.includes(kind)) {
        return { kind, memo: rest };
      }
    }

    // 구분자 없는 기존 데이터 호환
    const matched = this.applicationKindOptions.find(
      (kind) => text === kind || text.startsWith(kind)
    );
    if (matched) {
      return {
        kind: matched,
        memo: text.slice(matched.length).replace(/^\s+/, '')
      };
    }

    return { kind: '', memo: text };
  }

  /*******************************************************************************
    설  명 : 신청종류를 요청메모 앞에 합치기 (구분자로 구분, 중복 제거)
  *******************************************************************************/
  composeRequestMemoWithKind(kind: string, memo: string): string {
    const parsed = this.parseRequestMemoKind(memo);
    const rest = parsed.memo;
    const selected = (kind || '').trim();
    if (!selected) return rest;
    return rest ? `${selected}${this.applicationKindDelimiter}${rest}` : selected;
  }  

  /*******************************************************************************
    설  명 : 빌드폼 생성
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  buildForm(): void {
    let tmp = {
      application_model_seq: [ '', [] ],
      application_request_seq: [ '', [] ],      
      IAT_code: [ '4000', [] ],
      EIG_code: [ '3500', [] ],
      company_seq: [ '', [] ],
      company_name: [ '', [Validators.maxLength(100)] ],
      getCompanyInfo: [ '', [Validators.maxLength(100)] ],
      name_kor: [ '', [Validators.maxLength(50)] ],
      com_number: [ '', [Validators.pattern('^[0-9-]+$'), Validators.minLength(10), Validators.maxLength(12)] ],
      zipcode: [ '', [Validators.maxLength(5)] ],
      com_address: [ '', [Validators.maxLength(200)] ],
      addressDetail: [ '', [] ],
      com_tel: [ '', [Validators.maxLength(20)] ],
      com_fax: [ '', [Validators.maxLength(20)] ],
      job: [ '', [Validators.maxLength(100)] ],
      job1: [ '', [Validators.maxLength(100)] ],
      com_gbn: [ '', [] ],
      application_date: [ '', [Validators.required, Validators.maxLength(100)] ],
      applicant_name: [ '', [Validators.required, Validators.maxLength(50)] ],
      applicant_hp: [ '', [Validators.required, Validators.maxLength(30)] ],
      applicant_email: [ '', [Validators.required, Validators.maxLength(100)] ],

      tab4_item_gbn_code: [ '', [Validators.required] ],
      tab4_item_seq: [ '', [] ],
      tab4_item_code: [ '', [] ],
      tab4_custmer_item: [ '', [Validators.maxLength(200)] ],
      tab4_IRG_code: [ '', [] ],
      tab4_IRG_NAME: [ '', [] ],
      tab4_IRG_name: [ '', [] ],
      tab4_IRG_code_gas: [ '', [] ],
      tab4_model_name: [ '', [Validators.maxLength(250)] ],
      tab4_standard_model_name: [ '', [Validators.maxLength(50)] ],
      tab4_apply_model_name: [ '', [Validators.maxLength(50)] ],
      tab4_kind_grade: [ '', [Validators.maxLength(50)] ],
      tab4_apply_reason: [ '', [Validators.maxLength(150)] ],
      tab4_apply_standard: [ '', [Validators.maxLength(20)] ],
      tab4_file: [ '', [] ],
      tab4_files: [[], []],
      tab4_request_memo: [ '', [] ],
      tab4_agree: [ false, [Validators.requiredTrue] ],
      tab4_radio: [ '', [Validators.required] ],
    }

    this.form = this.formBuilder.group(tmp);

    this.form.valueChanges.subscribe(data => {
      this.utilService.updateFormErrors( this.form, this.formErrors );
    });
  }

  /*******************************************************************************
    설  명 : 데이터 로딩 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.getCommonList();
    if (this.seq) {
      this.btnName = '저장';
      this.getInspectionApplicationInfo();
    } else {
      this.getCompanyInfo();
    }

    // 업로드 허용 파일 설정
    var filetype: string[] = ['image', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'hwp'];
    //var filetype: string[] = this.boardInfo.upload_file_type.split('|');
    //let imagetype: string[] = this.boardInfo.upload_image_type.split('|');

    // 업로더 생성
    this.uploader = new FileUploader({
      url: URL,
      itemAlias: 'file',
      maxFileSize: 50 * (1024 * 1024), // 최대 업로드 허용 용량
      allowedFileType: filetype // 허용 업로드 파일 타입
    });

    // 파일업로드 설정
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      this.uploadProgress = '0%';
    };

    // 업로드 폼생성시 처리
    this.uploader.onBuildItemForm = (fileItem: FileItem, form: any) => {
      form.append( "token", this.globals.token );
    };

    // 업로드시 프로그레스바 처리
    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      this.uploadProgress = progress + '%';
    };

    // 업로드 용량 초과시 처리
    this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
      if( filter.name == 'fileSize' ) {
        this.toastrService.error( '파일 업로드 용량(50MB)을 초과하였습니다.', '파일 업로드');
      } else if( filter.name == 'fileType' ) {
        this.toastrService.error( '허용되는 업로드 파일 타입이 아닙니다.', '파일 업로드');
      }

      // indicator 표시 숨김
      setTimeout (() => {
        this.globals.indicator.next(false);
      });
    };

    // 파일업로드 완료시 처리
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      response = $.parseJSON( response );

      if( response.result ) {
        this.toastrService.success( response.message, '파일 업로드');

        let files = this.form.controls.tab4_files.value;

        files.push({
          seq:'0',
          url: config.baseUrl + response.url.replace(/\\/gi, '/'),
          origin: response.origin_filename,
          size: response.size,
          thumbnail: response.thumbnail.replace(/\\/gi, '/'),
          thumbnail_result: response.thumbnail_result,
        });

        this.form.patchValue( {tab4_files: files} );

      } else {
        this.toastrService.error( response.message, '파일 업로드');
      }

      // indicator 표시 숨김
      this.globals.indicator.next(false);
    };
  }

  /*******************************************************************************
    설  명 : 공통코드 품목구분 가져오기
    입력값 : code
    리턴값 : 없음
  *******************************************************************************/
  getCommonList() {
    if( this.commonList.length < 1 ) {
      this.commonCodeService.getCommonListCode('ITG').then(response => {
        if ( response.ResultCode ) {
          this.commonList = response.data;
        }
      })
    }
  }

  /*******************************************************************************
    설  명 : 품목 선택 시
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  onChange($event: any) {
    if (this.now_item_code > '') {
      this.form.patchValue({tab4_item_code: this.now_item_code});
    } else {
      this.form.patchValue({tab4_item_code: $event.target.value});
    }    
    this.getInspectionProductList()
    this.onChangeItem('');
  }

  onChangeItem($event: any) {
    if ($event) {
      this.form.patchValue({tab4_item_seq: $event.target.value});
    } else {
      this.form.patchValue({tab4_item_seq: this.now_item_seq});
    }
    this.inspectionItemCategoryNew();
  }

  /*******************************************************************************
    설  명 : inspection 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  inspectionItemCategoryNew() {
    this.InspectionBasicService.inspectionItemCategoryNew({
      CRUD: 'R',
      isMaster: true,
      item_gbn_code: this.form.value.tab4_item_gbn_code,
      item_seq: this.form.value.tab4_item_seq
    }).then(res => {
      if(res.ResultCode) {
        const data = res.data.map((item: any) => ({...item, IRG_name: item.IRG_NAME}));

        this.inspectionList = data.filter((item: any) => item.IRG_code.replace(/^(0000|30[3|4].+)/, ''))
        this.inspectionKSList = data.filter((item: any) => !item.IRG_code.replace(/^(30[3|4].+$)/, ''))
        .map((item: any) => ({
          ...item,
          id: item.IRG_code,
          text: item.IRG_name
        }))

        if(this.form.value.tab4_IRG_code_gas !== '') {
          this.form.value.tab4_IRG_code_gas.split('|')
          .forEach((item: any) => this.IRGCodeGasArray.push(
            this.inspectionKSList.find((_item: any) => _item.IRG_code == item)));
        } else {
          this.IRGCodeGasArray = [];
        }
      }
    })
  }

  getParams() {
    const item = this.productList.find((item: any) => item.seq == this.form.value.tab4_item_seq) || {}
    const irg = this.inspectionList.find((item: any) => item.IRG_code == this.form.value.IRG_code) || {}

    return {
      item_code: this.form.value.tab4_item_code,
      item_gbn_code: this.form.value.tab4_item_gbn_code,
      item_seq: this.form.value.tab4_item_seq,
      IRG_code: this.form.value.tab4_IRG_code,
      IRG_NAME: irg.IRG_name,
      IRG_name: irg.IRG_name
    }
  }

  /*******************************************************************************
    설  명 : 품목 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getInspectionProductList() {
    const data = this.getParams();

    // this.InspectionBasicService.getInspectionProductList({
    //   product: data.item_gbn_code,
    //   productDetail: data.item_code
    this.InspectionBasicService.getInspectionProducts({
      ...data
    }).then(res => {
      if(res.ResultCode) this.productList = res.data.map((item: any) => ({
        ...item,
        label: item.item_full_name
      }))
    })
  }


  /*******************************************************************************
    설  명 : 공통코드 품목 가져오기
    입력값 : code
    리턴값 : 없음
  *******************************************************************************/
  getCommonDetailList() {
    if( this.commonDetailList.length < 1 ) {
      this.commonCodeService.getCommonListCode('ITM').then(response => {
        if ( response.ResultCode ) {
          for( let list of response.data ) {
            if( list.c1 == this.form.value.tab4_item_gbn_code ) {
              this.commonDetailList.push(list);
            }
          }
        }
      })
    }
  }

    /*******************************************************************************
    설  명 : 품목구분 클릭 시
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  onClickBtn($event: any, type: any) {
    if( type == 'gbn_code' ) {
      this.form.patchValue({
        tab4_item_gbn_code: $event.common_code,
        tab4_item_code: '',
        tab4_item_seq: '',
        tab4_IRG_code: '',
        tab4_IRG_code_gas: ''
      });
      if (this.now_item_gbn_code > '') {
        this.form.patchValue({tab4_item_gbn_code : this.now_item_gbn_code});
      }      

      this.commonDetailList = []
      this.productList = []
      this.inspectionList = []
      this.inspectionKSList = []
      this.requestList = {}

    } else if( type == 'report_type' ) {
      // this.params.report_type = $event.common_code;

    } else if( type = 'inspection_place' ) {
      // this.params.inspection_place = $event;
      // this.params.inspection_place == null ? this.params.inspection_place_address = '' : this.params.inspection_place_address;
    }

    this.getCommonDetailList()
  }

  /*******************************************************************************
    설  명 : 파일 변경시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  handleUploadFileChanged(event) {
    this.uploader.clearQueue();

    // 파일 없을 경우 return false;
    if( event.target.files.length < 1 ) return false;

    // 전체 허용 용량 검증

    let files:File[] = event.target.files;
    let filteredFiles:File[] = [];
    for(var f of files) {
      filteredFiles.push(f);
    }

    let options = null;
    let filters = null;

    this.uploader.addToQueue(filteredFiles, options, filters);

    // indicator 표시
    this.globals.indicator.next(true);

    this.uploader.uploadAll()
  }

  /*******************************************************************************
    설  명 : 확장명 가져오기
    입력값 : filename
    리턴값 : ext
  *******************************************************************************/
  getExt( filename ) {
    if( typeof filename == 'undefined' ) return '';
    else return filename.substr(filename.lastIndexOf('.') + 1);
  }

  /*******************************************************************************
    설  명 : 콤마 표시
    입력값 : 숫자
    리턴값 : 콤마 숫자
  *******************************************************************************/
  getComma( num ) {
    var str = String(num);
    return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
  }

  /*******************************************************************************
    설  명 : 파일 삭제
    입력값 : 파일
    리턴값 : 없음
  *******************************************************************************/
  deleteFile( index ) {
    if( confirm("선택하신 파일을 삭제하시겠습니까?") ) {
      let tmp = this.form.controls.tab4_files.value;

      tmp.splice( index, 1 );

      this.form.patchValue({tab4_files: tmp});
    }
  }

  /*******************************************************************************
    설  명 : 파일 삭제
    입력값 : 업로드 파일 정보
    리턴값 : 없음
  *******************************************************************************/
  deleteUploadFile( upload: any, index: any ) {
    if( confirm("선택하신 파일을 삭제하시겠습니까?") ) {
      /*
      this.boardService.deleteUploadFile( upload.board_id, upload.board_seq, upload.seq ).then( response => {
        if( response.ResultCode ) {
          this.boardData.upload.splice( index, 1 );

          this.toastrService.success( response.ResultMessage, '게시글 첨부파일 삭제');
        } else {
          this.toastrService.error( response.ResultMessage, '게시글 첨부파일 삭제');
        }
      });
      */
    }
  }

  /*******************************************************************************
    설  명 : 업로드 된 파일 명이 이미지 인지 체크
    입력값 : 확장명
    리턴값 : true / false
  *******************************************************************************/
  checkImage( ext: string ) {
    let extArray = ['jpg', 'jpeg', 'gif', 'bmp', 'png'];

    if( extArray.indexOf( ext.toLowerCase() ) == -1 ) return false;
    else return true;
  }

  /*******************************************************************************
    설  명 : 표준개발협력제안
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  changeChecked(e: any) {
    this.form.patchValue({ tab4_radio: e.target.value });
  }

  /*******************************************************************************
    설  명 : 공통코드 저장
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  public submit() {
    this.utilService.makeFormDirtyAndUpdateErrors(this.form, this.formErrors);

    if( !this.form.valid ) {
      this.toastrService.error('필수 입력 항목을 확인해 주세요.', '안전확인시험검사 신청');
      return;
    }

    const itemSeq = this.form.value.tab4_item_seq;
    const hasItem = itemSeq && itemSeq !== 'undefined';
    const hasCustmerItem = (this.form.value.tab4_custmer_item || '').trim() !== '';
    if( !hasItem && !hasCustmerItem ) {
      this.toastrService.error('품목을 선택하거나 목록에 없는 요청 품목을 입력해 주세요.', '안전확인시험검사 신청');
      return;
    }

    let params = {};
    for(let key in this.form.value) {
      if( key.substr(0, 5) === 'tab4_' ) {
        params[key.substr(5)] = this.form.value[key];
      } else {
        params[key] = this.form.value[key];
      }
    }
    params['seq'] = this.seq;
    params['files'] = this.form.value.tab4_files || [];
    params['EIG_code'] = '3500';
    params['request_memo'] = this.composeRequestMemoWithKind(
      this.form.value.tab4_radio,
      this.form.value.tab4_request_memo
    );

    this.hInspectionService.setApplicationInspection(params).then((response) => {
      if( response.ResultCode ) {
        this.toastrService.success('정상적으로 등록되었습니다.', '안전확인시험검사 신청');
        this.activeModal.close();
      } else {
        this.toastrService.error( response.ResultMessage, '안전확인시험검사 신청');
      }
    }, (error) => {
      this.toastrService.error(error?.message || error || '신청 처리 중 오류가 발생했습니다.', '안전확인시험검사 신청');
    });
  }
}
